// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fic-screen-portal {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  z-index: 510;
  transform: translateX(100%);
  transition: transform 0.2s ease-out;
}
fic-screen-portal.fic-screen-show {
  transform: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fic-screen/fic-screen-portal.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,mCAAA;AACJ;AACI;EACI,eAAA;AACR","sourcesContent":["fic-screen-portal {\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n    background: #fff;\r\n    z-index: 510; // do not set greater them materials dialog\r\n    transform: translateX(100%);\r\n    transition: transform 0.2s ease-out;\r\n\r\n    &.fic-screen-show {\r\n        transform: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
